<template>
    <v-dialog v-model="openDetails" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark color="light-green darken-4">
                <v-btn icon dark @click="closeDetails">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title style="padding-left: 0px !important;">{{ $t('detail-lbl-game-detail') }}</v-toolbar-title>
            </v-toolbar>
            <v-carousel cycle interval="3000" height="auto">
                <v-carousel-item v-for="(screen, idx) in game.screens" :src="concatBaseUrl(screen)" :key="idx" eager/>
            </v-carousel>

            <v-list three-line subheader>
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title>{{ $t('detail-lbl-title') }}</v-list-item-title>
                        <v-list-item-subtitle>{{ game.title }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title>{{ $t('detail-lbl-category') }}</v-list-item-title>
                        <v-list-item-subtitle>
                            <v-chip v-for="(genre, idx) in genres" :key="idx" class="ma-2" small dense>{{ genre }}</v-chip>
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title>{{ $t('detail-lbl-current-price') }}</v-list-item-title>
                        <v-list-item-subtitle><v-icon small>mdi-currency-{{ currency }}</v-icon> {{ curPrice }} <span v-if="game.isOnSale">(<strike>{{ formated(game.oriPrice) }}</strike> / {{ percent }}%)</span></v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title>{{ $t('detail-lbl-platform') }}</v-list-item-title>
                        <v-list-item-subtitle>
                            <v-chip v-for="(platform, idx) in platforms" :key="idx" class="ma-2" small dense>{{ platform }}</v-chip>
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title>{{ $t('detail-lbl-release-date') }}</v-list-item-title>
                        <v-list-item-subtitle>{{ game.releaseDate }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title>{{ $t('detail-lbl-store') }}</v-list-item-title>
                        <v-list-item-subtitle><a :href="storeUrl" target="_blank">{{ storeUrl }}</a></v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
            
            <v-divider></v-divider>

            <v-list v-if="discounts.length > 0" flat>
                <v-subheader>{{ $t('detail-lbl-discount-history') }}</v-subheader>
                <v-list-item-group color="primary">
                    <v-list-item dense v-for="(discount, idx) in discounts" :key="idx">
                        <v-list-item-icon style="margin-right: 10px;">
                            <v-icon :color="discount.directionColor" small>{{ discount.direction }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title><v-icon small>mdi-currency-{{ currency }}</v-icon> {{ formated(discount.price) }} ({{ calcPercent(discount.price) }}%)</v-list-item-title>
                            <v-list-item-subtitle>{{ discount.startDateTime }} ~ {{ discount.endDateTime }}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-item-group>
            </v-list>

            <v-divider></v-divider>
        </v-card>
    </v-dialog>
</template>

<script>
import moment from 'moment'
import numeral from 'numeral'
import _ from 'lodash'

const TIME_DIFF = 9

export default {
    props: [ 'game', 'openDetails', 'locale' ],
    computed: {
        genres () {
            if (this.game.genres)
                return this.game.genres.map(genre => _.words(genre).map(inGenre => _.capitalize(inGenre)).join(' '))
            else return []
        },
        platforms () {
            let platformArr = []
            if (this.game.isPlatformXsx) platformArr.push('Xbox Series X|S')
            if (this.game.isPlatformXo) platformArr.push('Xbox One')
            if (this.game.isPlatformPc) platformArr.push('PC')
            return platformArr
        },
        curPrice () {
            return (this.game.isOnSale) ? this.formated(this.game.curPrice) : this.formated(this.game.oriPrice)
        },
        percent () {
            return numeral((1 - (this.game.curPrice / this.game.oriPrice)) * 100).format('0')
        },
        discounts () {
            let basePrice = this.game.oriPrice
            if (this.game.discounts) {
                return this.game.discounts.map(discount => {
                    let direction = ''
                    let directionColor = ''
                    if (basePrice < discount.sprice) {
                        direction = 'mdi-arrow-up'
                        directionColor = 'red'
                    } else if (basePrice == discount.sprice) {
                        direction = 'mdi-minus'   
                        directionColor = 'grey'
                    } else {
                        direction = 'mdi-arrow-down'
                        directionColor = 'blue'
                    }
                    basePrice = discount.sprice

                    return {
                        directionColor,
                        direction, 
                        price: discount.sprice,
                        startDateTime: this.calcDate(discount.sdate),
                        endDateTime: this.calcDate(discount.edate)
                    }
                })
            } else {
                return []
            }
        },
        storeUrl () {
            return `https://www.microsoft.com/${this.locale}/p/${this.game.gameUrlId}/${this.game.bid}`
        },
        currency () {
            return (this.locale == 'ko-kr') ? 'krw' : 'usd'
        }
    },
    methods: {
        concatBaseUrl (url) {
            return `https://store-images.s-microsoft.com/image/${url}`
        },
        formated (price) {
            return (this.locale == 'ko-kr') ? numeral(price).format('#,##0') : numeral(price).format('0.00')
        },
        calcPercent (discountPrice) {
            return numeral((1 - discountPrice / this.game.oriPrice) * 100).format('0')
        },
        calcDate (date) {
            if (date) {
                return moment(date, 'YYYY-MM-DD HH:mm:ss').add(TIME_DIFF, 'hours').format('YYYY-MM-DD')
            } else {
                return this.$t('detail-lbl-on-sale')
            }
            
        },
        closeDetails () {
            this.$emit('close-details')
        }
    }
}
</script>

<style scoped>

</style>